import React from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';

const NotFoundPage = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const history = useHistory();
  // const { loading } = useSelector((state: RootState) => state.ui[.typePrefix] || {});

  return <h1>not found</h1>;
};

export default NotFoundPage;
